// Altın Teklifim API için ince fetch sarmalayıcı.
// - Base URL .env'den (REACT_APP_API)
// - Her isteğe Authorization: Bearer ekler
// - 401'de oturumu temizler ve giriş sayfasına yönlendirir
// - Hata gövdesinden anlamlı mesaj çıkarır

import { token, oturumTemizle } from './auth';

const TABAN = process.env.REACT_APP_API || 'http://localhost:5081';

class ApiHata extends Error {
  constructor(mesaj, durum) {
    super(mesaj);
    this.durum = durum;
  }
}

async function istek(yol, secenekler = {}) {
  const basliklar = { ...(secenekler.headers || {}) };
  const t = token();
  if (t) basliklar['Authorization'] = `Bearer ${t}`;

  let govde = secenekler.body;
  if (govde && typeof govde === 'object' && !(govde instanceof FormData)) {
    basliklar['Content-Type'] = 'application/json';
    govde = JSON.stringify(govde);
  }

  let yanit;
  try {
    yanit = await fetch(`${TABAN}${yol}`, { ...secenekler, headers: basliklar, body: govde });
  } catch (e) {
    throw new ApiHata('Sunucuya ulaşılamadı. API çalışıyor mu?', 0);
  }

  if (yanit.status === 401) {
    oturumTemizle();
    if (window.location.pathname !== '/login') window.location.href = '/login';
    throw new ApiHata('Oturum süresi doldu. Lütfen tekrar giriş yapın.', 401);
  }

  if (yanit.status === 204) return null;

  const tip = yanit.headers.get('content-type') || '';
  const veri = tip.includes('application/json') ? await yanit.json().catch(() => null) : await yanit.text();

  if (!yanit.ok) {
    const mesaj =
      (veri && (veri.mesaj || veri.title || veri.detail || veri.hata)) ||
      (typeof veri === 'string' && veri) ||
      `İstek başarısız (${yanit.status})`;
    throw new ApiHata(mesaj, yanit.status);
  }

  return veri;
}

export const api = {
  get: (yol) => istek(yol, { method: 'GET' }),
  post: (yol, body) => istek(yol, { method: 'POST', body }),
  put: (yol, body) => istek(yol, { method: 'PUT', body }),
  del: (yol) => istek(yol, { method: 'DELETE' }),
  taban: TABAN,
};

export { ApiHata };

// ---- Yönetim uç noktaları --------------------------------------------------

export const yonetim = {
  giris: (kullaniciAdi, sifre) =>
    api.post('/api/yonetim/giris', { kullaniciAdi, sifre }),

  pano: () => api.get('/api/yonetim/pano'),

  kuyumcular: (onayDurumu, imlec, boyut = 20) =>
    api.get(sorgu('/api/yonetim/kuyumcular', { onayDurumu, imlec, boyut })),
  kuyumcuDetay: (id) => api.get(`/api/yonetim/kuyumcular/${id}`),
  kuyumcuDuzenle: (id, govde) => api.put(`/api/yonetim/kuyumcular/${id}`, govde),
  kuyumcuKarar: (id, onayla, redNedeni) =>
    api.post(`/api/yonetim/kuyumcular/${id}/karar`, { onayla, redNedeni }),

  kampanyalar: (onayDurumu, imlec, boyut = 20) =>
    api.get(sorgu('/api/yonetim/kampanyalar', { onayDurumu, imlec, boyut })),
  kampanyaKarar: (id, onayla, redNedeni) =>
    api.post(`/api/yonetim/kampanyalar/${id}/karar`, { onayla, redNedeni }),

  reklamlar: (onayDurumu, imlec, boyut = 20) =>
    api.get(sorgu('/api/yonetim/reklamlar', { onayDurumu, imlec, boyut })),
  reklamKarar: (id, onayla, redNedeni) =>
    api.post(`/api/yonetim/reklamlar/${id}/karar`, { onayla, redNedeni }),

  parametreler: () => api.get('/api/yonetim/parametreler'),
  parametreGuncelle: (anahtar, deger) =>
    api.put(`/api/yonetim/parametreler/${encodeURIComponent(anahtar)}`, { deger }),

  kampanyaTiklamaRaporu: (imlec, boyut = 50) =>
    api.get(sorgu('/api/yonetim/raporlar/kampanya-tiklama', { imlec, boyut })),
};

function sorgu(yol, params) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') usp.append(k, v);
  });
  const s = usp.toString();
  return s ? `${yol}?${s}` : yol;
}
